export const addWatchlist = (data) => {
    return (dispatch, getState) => {
        dispatch({ type: 'ADD_WATCHLIST', watchlist: data });
    }
};

export const removeWatchlist = (key) => {
    return (dispatch, getState) => {
        dispatch({ type: 'REMOVE_WATCHLIST', key: key });
    }
};
